<template>
  <div class="max-w-[800px] w-full">
    <div class="flex flex-wrap md:flex-nowrap justify-between mb-4 gap-4">
      <div class="font-normal text-xs leading-4 text-neutral-500 text-balance">
        Your secret API keys are listed below. <br />
        Do not expose your key in the browser or in any client-side code.
      </div>
      <Protect :permissions="[SYS_PERMISSIONS.SYS_API_CREATE]">
        <ApiTokenCreateDialog />
      </Protect>
    </div>
    <ApiTable />
  </div>
</template>

<script setup>
import Protect from '@/hoc/Protect.vue';
import { SYS_PERMISSIONS } from '@/constants.js';
import ApiTable from './components/api/ApiTable.vue';
import ApiTokenCreateDialog from './components/api/ApiTokenCreateDialog.vue';
</script>
